import React from "react";
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <a href="#" className="flex items-center gap-3" aria-label="Success Capital — accueil" data-id="element-114" data-mp="8u4tmrzsq3qi">
      <span className={`flex h-10 w-10 items-center justify-center rounded-full font-serif text-lg font-semibold ${inverted ? "bg-white text-brand" : "bg-brand text-white"}`} data-id="element-115" data-mp="3qacmvht0zlzg">
        S
      </span>
      <span className="flex flex-col leading-none" data-id="element-116" data-mp="mtnpalbf7mlx">
        <span className={`font-serif text-xl font-semibold ${inverted ? "text-white" : "text-ink"}`} data-id="element-117" data-mp="rsh2sdqpjdm3">
          Success Capital
        </span>
        <span className={`mt-1 text-[11px] ${inverted ? "text-white/70" : "text-muted"}`} data-id="element-118" data-mp="drmwc0n7zmq2">
          Conseil en investissement
        </span>
      </span>
    </a>;
}